<template lang="pug">
  div(
    v-if="mappingConfObject && options.length > 0"
  ).type-group.map-mapping-selector
    div.type
      label.checked
        span
        span.marker Тематическая карта
      label.new-check
        input.new-checkbox(type="checkbox" v-model="showMappingLayer")
        span
    div(
      v-show="showMappingLayer"
      v-for="option in options"
    ).group
      div.type
        label.checked.radioButton
          input(
            type="radio"
            v-model="selected"
            @change="onChange"
            :value="option.id"
          ).radio
          span
          span.marker {{option.name}}
    div.type
      label.checked
        span
        span.marker Эквидистанта
      label.new-check
        input.new-checkbox(
          type="checkbox"
          v-model="showEquidistant"
        )
        span
    div(
      v-show="showEquidistant"
    ).group
      div.type
        label
          input(
            type="text"
            v-model="equidistant"
          )
    div.type
      label.checked
        span
        span.marker Эквидистанта населенного пункта
      label.new-check
        input.new-checkbox(
          type="checkbox"
          v-model="showEquidistantGeo"
        )
        span
    div(
      v-show="showEquidistantGeo"
    ).group
      div.type
        label
          input(
            type="text"
            v-model="equidistantGeo"
          )
    div(
      style="display: block!important;"
    ).type
      div.input-w
        label(
          style="display: inline-block;padding: 10px;"
          for="rosreestr"
        ) Подложка
        select(
          v-model="rosreestr_view"
          id="rosreestr"
        ).rosreestr_view_select
          option(
            value="rosreestr_cadastre"
          ) Росреестр: Кадастр
          option(
            value="osm"
          ) OSM
          option(
            value="yandex"
          ) Яндекс.Карты
          option(
            value="satellite"
          ) Яндекс.Спутник
      div(
        style="padding-top: 13px;"
      )
        e-address(
          placeholder="Адрес, координаты или кадастр. номер"
          :model="$data"
          name="rosreestrSearch"
          style="width: 100%"
          @enter="searchRosreestr"
          @selectItem="searchRosreestr"
        ).search
</template>

<script>


  export default {
    name: 'map-mapping-selector',
    props: {
      mappingConfObject: Object,
      selectedMappingObject: [Number, String]
    },
    mounted() {
      this.$emitter.listen('mapInit', () => {
        if (this.$route?.query?.tile) {
          this.rosreestr_view = this.availableTiles[this.$route.query.tile] ?? 'osm'
        }
      })
      // иницииализируем радиус для обычной эквидистанты..
      this.$emit('setEquidistant', this.equidistant);
    },
    data() {
      return {
        rosreestrSearch: '',
        availableTiles: {
          osm:       'osm',
          yandex:    'yandex',
          cadastre:  'cadastre',
          satellite: 'satellite'
        },
        rosreestr_view: 'osm',
        selected: '',
        showEquidistant: false,
        equidistant: 1000,
        showEquidistantGeo: false,
        equidistantGeo: 1000
      }
    },
    watch: {
      'selectedMappingObject': 'onSelectedMappingObject',
      'showMappingLayer': 'onShowMappingLayer',
      'showEquidistant': 'onShowEquidistant',
      'equidistant': 'setEquidistant',
      'rosreestr_view': 'onRosreestrChangeView',
      showEquidistantGeo(){ this.$emit('showEquidistantGeo', this.showEquidistantGeo) },
      equidistantGeo(){ this.$emit('equidistantGeo', this.equidistantGeo) },
    },
    computed: {
      isCadasterNumber() {
        return this.rosreestrSearch.match(/\d{2}:\d{2}:\d{1,7}:\d+/g) !== null
      },
      options() {
        let items = []
        for (let key in this.mappingConfObject) {
          items.push({
            id: key, name: this.mappingConfObject[key].title
          })
        }
        return items
      },
      showMappingLayer: {
        get() { return this.$store.state.showMappingLayer },
        set(value) {
          this.$store.commit('mappingLayer', value);
          // если выключили тематическю карту надо выключить и используемые радиокнопки (типы тематических карт)
          if (!value) {
            this.selected = '';
            this.onShowMappingLayer(false);
          }
        }
      }
    },
    methods: {
      searchRosreestr() {
        if (this.rosreestrSearch.length <= 2) {
          this.$e.warningBox('Введите корректный адрес или кадастровый номер для поиска')
          return
        }
        this.$emitter.emit('searchRosreestr', this.rosreestrSearch)
      },
      onShowMappingLayer(newVal) {
        if (newVal === true) {
          this.onSelectedMappingObject(this.savedSelected)
        } else {
          this.savedSelected = this.selected
          this.onSelectedMappingObject('')
        }
        this.onChange();
      },
      onShowEquidistant(value) { this.$emit('showEquidistant', value) },
      setEquidistant(setEquidistant) { this.$emit('setEquidistant', setEquidistant) },
      onRosreestrChangeView(value) {
        this.$router.replace({name: this.$route.name, query: {...this.$route.query, tile: value}})
        this.$emit('rosreestrChangeView', value)
      },
      onSelectedMappingObject(val) { this.selected = val },
      onChange() { this.$emit('change', this.selected) }
    }
  }
</script>
<style lang="scss">
  .input-w {
    width: 100%;
  }
  .line {
    padding-bottom: 0 !important;
  }
  .rosreestr_view_select {
    float: right;
    width: 62%;
  }
</style>
